if (!customElements.get('cart-drawer-upsell')) {
  customElements.define(
    'cart-drawer-upsell',
    class CartDrawerUpsell extends HTMLElement {
      connectedCallback() {
        this.toggleInput = this.querySelector('[data-cart-upsell-upgrade]');
        this.errorElement = this.querySelector('.cart-drawer-upsell__error');
        this.loadingElement = this.querySelector('.cart-drawer-upsell__loading');
        if (!this.toggleInput || this.toggleInput.dataset.bound === 'true') return;
        this.toggleInput.dataset.bound = 'true';
        this.toggleInput.addEventListener('change', this.onToggle.bind(this));
      }

      setError(message) {
        if (!this.errorElement) return;
        if (!message) {
          this.errorElement.classList.add('hidden');
          this.errorElement.textContent = '';
          return;
        }
        this.errorElement.textContent = message;
        this.errorElement.classList.remove('hidden');
      }

      setLoading(isLoading) {
        this.classList.toggle('is-loading', isLoading);
        if (this.loadingElement) this.loadingElement.classList.toggle('hidden', !isLoading);
        if (this.toggleInput) {
          this.toggleInput.disabled = isLoading;
        }
      }

      async onToggle(event) {
        const input = event.currentTarget;
        if (!input.checked) return;

        const variantId = this.dataset.variantId;
        if (!variantId) {
          input.checked = false;
          return;
        }

        const cartDrawer = document.querySelector('cart-drawer');
        this.setError('');
        this.setLoading(true);

        try {
          await fetch('/cart/clear.js', {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          });

          const sectionIds = cartDrawer
            ? cartDrawer.getSectionsToRender().map((section) => section.id)
            : ['cart-drawer', 'cart-icon-bubble'];

          const body = JSON.stringify({
            items: [{ id: Number.parseInt(variantId, 10), quantity: 1 }],
            sections: sectionIds.join(','),
            sections_url: window.routes.cart_url,
          });

          const response = await fetch(`${window.routes.cart_add_url}`, {
            ...fetchConfig(),
            body,
            credentials: 'include',
          });

          const parsedState = await response.json();

          if (parsedState.status) {
            input.checked = false;
            this.setError(parsedState.description || 'Unable to upgrade your cart. Please try again.');
            return;
          }

          if (cartDrawer) {
            if (cartDrawer.classList.contains('is-empty')) {
              cartDrawer.classList.remove('is-empty');
            }
            await cartDrawer.renderContents(parsedState);
          } else {
            window.location = window.routes.cart_url;
          }
        } catch (error) {
          console.error(error);
          input.checked = false;
          this.setError('Unable to upgrade your cart. Please try again.');
        } finally {
          this.setLoading(false);
        }
      }
    }
  );
}
